<template>
	<div class="sys-auth vue-padding radius" style="height: 742px">
		<!-- <div class="tips">{{$route.name}}</div> -->
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane :label="$t('authorization.userRole')" name="userRole">
				<user-role :roleList="roleList" :roles-loading="rolesLoading"></user-role>
			</el-tab-pane>
			<el-tab-pane :label="$t('authorization.roleAuth')" name="userAuth">
				<role-auth :roleList="roleList" :roles-loading="rolesLoading"></role-auth>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import userRole from "_c/authority/auth/UserRole";
import roleAuth from "_c/authority/auth/RoleAuth";
import { checkPerm, checkRole } from "../../utils/permission";

export default {
	name: "Authorization",
	components: {
		roleAuth,
		userRole,
	},
	inject: ["reload"],
	data() {
		return {
			activeName: "userRole",
			roleList: [],
			// 角色请求在飞时告诉子面板，让它显示 loading 而不是「No Data」
			rolesLoading: true,
			defaultProps: {
				label: "name",
				children: "children",
			},
		};
	},
	mounted() {
		this.rolesLoading = true;
		this.$api
			.request(this.$url.AuthorityRole.loadRole, this.$method.get)
			.then(res => {
				console.log(res.data);
				if (res.code === 0) {
					this.roleList = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
			.catch(() => {
				this.$message.error(this.$t("authorization.roleFail"));
			})
			.finally(() => {
				this.rolesLoading = false;
			});
	},
	methods: {
		handleClick(tab) {},
		checkPerm,
		checkRole,
	},
};
</script>

<style lang="scss">
.sys-auth {
	.el-input {
		width: 100%;
	}

	.roleFilter,
	.authFilter {
		padding-left: 20px;
		margin-bottom: 10px;
	}

	.el-tree-node__content {
		height: 0.3rem;
		line-height: 0.3rem;
	}
}
</style>
